import { Descriptions, Divider, Space, Tag, Typography } from 'antd'
import {
  APPLICATION_STATUS_META,
  formatApplicationDateTime
} from '@/features/access/const/application-review-details.ts'
import type { ApplicationReviewRecord } from './application-review-modal.tsx'

export function ApplicationSummary({ application }: { application: ApplicationReviewRecord }) {
  return (
    <>
      <Descriptions
        column={2}
        items={[
          { key: 'name', label: '申请人', children: application.applicantName },
          {
            key: 'status',
            label: '状态',
            children: (
              <Tag color={APPLICATION_STATUS_META[application.status].color}>
                {APPLICATION_STATUS_META[application.status].text}
              </Tag>
            )
          },
          {
            key: 'email',
            label: '登录邮箱',
            span: 2,
            children: <Typography.Text copyable>{application.account.email}</Typography.Text>
          },
          { key: 'phone', label: '联系电话', children: application.applicantPhone || '—' },
          {
            key: 'createdAt',
            label: '提交时间',
            children: formatApplicationDateTime(application.createdAt)
          }
        ]}
        size="small"
      />
      <Divider size="small" />
    </>
  )
}

export function ProcessedApplicationDetails({ application }: { application: ApplicationReviewRecord }) {
  return (
    <Descriptions
      bordered
      column={1}
      items={[
        {
          key: 'member',
          label: '绑定成员',
          children: application.member
            ? `${application.member.name}${application.member.jobTitle ? ` · ${application.member.jobTitle}` : ''}`
            : '—'
        },
        {
          key: 'roles',
          label: '分配角色',
          children:
            application.assignedRoleCodes.length > 0 ? (
              <Space size={[4, 4]} wrap>
                {application.assignedRoleCodes.map((role) => (
                  <Tag key={role}>{role}</Tag>
                ))}
              </Space>
            ) : (
              '—'
            )
        },
        {
          key: 'operator',
          label: '处理人',
          children: application.decidedBy?.member?.name ?? application.decidedBy?.email ?? '—'
        },
        {
          key: 'reason',
          label: '拒绝原因',
          children: application.rejectionReason || '—'
        }
      ]}
      size="small"
    />
  )
}
